import { useEffect, useState } from 'react'

import { Box, Divider, Stack, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import Summary from 'components/summary/summary'
import { useMappedTranslation, useScloud } from 'hooks'

import { AutomationTagIds } from '../../../../../assets/test/test-automation-tag-id'
import IconApps from '../assets/images/apps.png'
import IconBackup from '../assets/images/backup.png'
import IconCloud from '../assets/images/cloud.png'

const SCloudSummary = () => {
  const t = useMappedTranslation()
  const theme = useTheme()

  const [syncedDataSize, setSyncedDataSize] = useState(0)
  const [backupDataSize, setBackupDataSize] = useState(0)

  const { scloud, isInitializing } = useScloud(true)

  const getByteSize = (size) => {
    const byteUnits = ['KB', 'MB', 'GB', 'TB']

    for (let i = 0; i < byteUnits.length; i++) {
      size /= 1024
      if (size < 1024) return `${size.toFixed(2)} ${byteUnits[i]}`
    }
  }

  useEffect(() => {
    if (!isInitializing) {
      setSyncedDataSize(scloud.syncedData.amountSize)
      setBackupDataSize(scloud.backupData.amountSize)
    }
  }, [scloud, isInitializing])

  return (
    <Summary
      size={'small'}
      pageUrl={'/dashboard/services/scloud'}
      isLoading={isInitializing}
      titleIcon={IconCloud}
      title={t('scloud.title')}
      content={
        syncedDataSize === 0 && backupDataSize === 0 ? (
          <Box sx={{ pt: { xs: '8px', md: '0' }, width: '100%' }}>
            <Typography variant='body1'>{t('scloud.empty')}</Typography>
          </Box>
        ) : (
          <Stack
            direction='row'
            divider={<Divider orientation='vertical' sx={{ mx: '23px' }} />}
            sx={{ width: '100%', pt: { xs: '8px', md: '0' } }}
            data-testid={AutomationTagIds['cards.dashboard-scloud-data']}
          >
            <Stack direction='row' alignItems='center' justifyContent='flex-start' sx={{ width: '100%' }}>
              <Box component='img' src={IconApps} sx={{ width: '40px', height: '40px', mr: '10px' }} alt='' />
              <Stack direction='column' justifyContent='flex-start'>
                <Box sx={{ width: '100%', lineHeight: '22px' }}>
                  <Typography variant='label2' sx={{ color: theme.palette.secondary.light }}>
                    {t('scloud.syncedData')}
                  </Typography>
                </Box>
                <Box sx={{ width: '100%' }}>
                  <Typography>{getByteSize(syncedDataSize)}</Typography>
                </Box>
              </Stack>
            </Stack>
            <Stack direction='row' alignItems='center' justifyContent='flex-start' sx={{ width: '100%' }}>
              <Box component='img' src={IconBackup} sx={{ width: '40px', height: '40px', mr: '10px' }} alt='' />
              <Stack direction='column' justifyContent='flex-start'>
                <Box sx={{ width: '100%', lineHeight: '22px' }}>
                  <Typography variant='label2' sx={{ color: theme.palette.secondary.light }}>
                    {t('scloud.backupData')}
                  </Typography>
                </Box>
                <Box sx={{ width: '100%' }}>
                  <Typography>{getByteSize(backupDataSize)}</Typography>
                </Box>
              </Stack>
            </Stack>
          </Stack>
        )
      }
    />
  )
}

export default SCloudSummary
